import "./sass/back-end-bunde.scss"

import "./js/core/setup"
import "./js/core/events"
import "./js/core/navigation"
import "./js/core/icons"


